class Performance

  constructor: ->
    @recordedFirstPage = false

  pageReady: ->
    if @recordedFirstPage then return
    if not Groupon.Performance then return

    Groupon.Performance.pageReady()

    @recordedFirstPage = true

module.exports = Performance
